import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Portfolio from "./portfolio.jsx"
import Blog_section from "./blogSection.jsx"
import Article from "./article.jsx"
function App() {
  return (
    <div className="App">
      <header className="App-header">
  
<Router>
    
        <Routes>
      <Route path = "/" element = {<Portfolio/>}/>
       <Route path = 'blog_section' element = {<Blog_section/>}/>
       <Route path="/blog/:id" element={<Article />} />
     
      </Routes>

      </Router>



      </header>
    </div>
  );
}

export default App;
